export class Loop {
  constructor(camera, scene, renderer, composer) {
    this.camera = camera;
    this.scene = scene;
    this.renderer = renderer;
    this.composer = composer;
    this.updatables = [];
  }

  start() {
    this.renderer.setAnimationLoop((time) => {
      this.update(time);
      if (this.composer) {
        this.composer.render();
      } else {
        this.renderer.render(this.scene, this.camera);
      }
    });
  }

  update(time) {
    this.updatables.forEach((obj) => obj.tick?.(time));
  }
}
